// src/components/overlay/EntryOverlay.jsx
import React from "react";
import {
  Modal,
  Box,
  Stack,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import SportsKabaddiIcon from "@mui/icons-material/SportsKabaddi";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { useNavigate } from "react-router-dom";

export default function EntryOverlay({
  open,
  onClose,
  mediaSrc = "https://res.cloudinary.com/dekoxefky/video/upload/v1761188757/Mi_video_1_pyhe4b.mp4",
  mediaAlt = "Arena",
  burnRoute = "/game/album?page=6",
  arenaRoute = "/game/arena",
  rankingRoute = "/game/album?page=7",
  miningRoute = "/game/album?page=8",
}) {
  const navigate = useNavigate();
  const go = (path) => {
    onClose?.();
    navigate(path, { replace: false });
  };

  const isVideo = /\.mp4$|\.webm$|\.ogg$/i.test(mediaSrc);

  const baseButtonSx = {
    position: "relative",
    py: 1.2,
    borderRadius: 2,
    fontWeight: 800,
    textTransform: "none",
    fontSize: "0.85rem",
    border: "2px solid rgba(255,215,128,0.85)",
    boxShadow: "0 0 10px rgba(0,0,0,0.8)",
    transition: "all 0.18s ease-out",
    "&:hover": {
      transform: "translateY(-2px) scale(1.01)",
      boxShadow: "0 0 20px rgba(255,213,79,1)",
    },
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          width: { xs: "90vw", sm: 600 },
          bgcolor: "rgba(22,22,26,0.96)",
          color: "#fff",
          borderRadius: 2,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.12)",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: "relative",
            width: "100%",
            aspectRatio: "16 / 7",
            bgcolor: "#000",
            overflow: "hidden",
          }}
        >
          {isVideo ? (
            <video
              src={mediaSrc}
              autoPlay
              loop
              muted
              playsInline
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <img
              src={mediaSrc}
              alt={mediaAlt}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          )}

          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 6,
              top: 6,
              color: "#fff",
              background: "rgba(0,0,0,0.45)",
              "&:hover": {
                background: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <Typography
            variant="h6"
            fontWeight={900}
            sx={{
              position: "absolute",
              left: 12,
              bottom: 8,
              fontSize: "1rem",
              textShadow: "0 2px 10px rgba(0,0,0,0.9)",
            }}
          >
            Welcome to the Arena!
          </Typography>
        </Box>

        {/* Body */}
        <Box sx={{ p: 2 }}>
          <Typography
            variant="body2"
            sx={{
              opacity: 0.9,
              fontSize: "0.8rem",
              lineHeight: 1.25,
            }}
          >
            Burn NFTs, battle in Arena Mode ⚔️ or start mining to earn VIPHUESO! ⛏️
            Check your position in the Global Ranking 🏆
          </Typography>

          <Divider
            sx={{
              my: 1.5,
              borderColor: "rgba(255,255,255,0.08)",
            }}
          />

          <Stack spacing={1}>
            <Button
              fullWidth
              onClick={() => go(burnRoute)}
              startIcon={<WhatshotIcon />}
              sx={{
                ...baseButtonSx,
                background:
                  "linear-gradient(135deg, #ff9800, #ffb300, #ffca28)",
              }}
            >
              🔥 Burn NFTs (get PP)
            </Button>

            <Button
              fullWidth
              onClick={() => go(arenaRoute)}
              startIcon={<SportsKabaddiIcon />}
              sx={{
                ...baseButtonSx,
                background:
                  "linear-gradient(135deg, #ab47bc, #ba68c8, #ce93d8)",
              }}
            >
              ⚔️ Enter Arena
            </Button>

            <Button
              fullWidth
              onClick={() => go(rankingRoute)}
              startIcon={<EmojiEventsIcon />}
              sx={{
                ...baseButtonSx,
                background:
                  "linear-gradient(135deg, #43a047, #66bb6a, #a5d6a7)",
              }}
            >
              🏆 View Ranking
            </Button>

            <Button
              fullWidth
              onClick={() => go(miningRoute)}
              startIcon={<EmojiEventsIcon />}
              sx={{
                ...baseButtonSx,
                background:
                  "linear-gradient(135deg, #ffa000, #ffc107, #ffe082)",
              }}
            >
              ⛏️ Mining Mode
            </Button>
          </Stack>
        </Box>
      </Box>
    </Modal>
  );
}
